import { render, staticRenderFns } from "./editshop.vue?vue&type=template&id=57646896&scoped=true"
import script from "./editshop.vue?vue&type=script&lang=js"
export * from "./editshop.vue?vue&type=script&lang=js"
import style0 from "./editshop.vue?vue&type=style&index=0&id=57646896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___f047bfa682af2a89903e2d84cf35ffa3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57646896",
  null
  
)

/* custom blocks */
import block0 from "./editshop.vue?vue&type=custom&index=0&blockType=div&style=max-width%3A403px%3Bmax-height%3A300px"
if (typeof block0 === 'function') block0(component)

export default component.exports